import React from "react";
import theme from "../../../styles/theme";



const Page53 = () => {
  return (
    <div>
    <h2>"Page 53" </h2>
    </div>

  );
};

export default Page53;
